/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 05.11.17.
 */

import React from "react";
import PropTypes from "prop-types";
import BaseActionWizardStep from "../../containers/BaseActionWizardStep";
import {SessionStore} from "../../services/Session";
import PasswordForm from "../../components/PasswordForm";

class StepAuthenticate extends BaseActionWizardStep {
    static propTypes = {
        /**
         * Authenticate user:
         *  - both - use session data
         *  - authkey - use session data
         */
        type: PropTypes.oneOf(["authkey", "both"]),

        onParamChange: PropTypes.func.isRequired,
        params: PropTypes.shape({
            hideForward: PropTypes.bool,
            hideBack: PropTypes.bool,
            disableForward: PropTypes.bool,
            disableBack: PropTypes.bool,
            password: PropTypes.string
        }).isRequired,
        prevParams: PropTypes.shape({
            hideForward: PropTypes.bool,
            hideBack: PropTypes.bool,
            disableForward: PropTypes.bool,
            disableBack: PropTypes.bool,
            componentProps: PropTypes.object
        })
    };

    static defaultProps = {};

    constructor(props) {
        super(props, {
            authSession: "session",
            session: SessionStore
        });

        this.state.email = this.state.session.currentRecord.person.email;
        this.state.authType = this.state.session.currentRecord.authType;

        this.onChange = this.onChange.bind(this);

    }

    render() {
        return (
            <PasswordForm
                validation={this.state.errors}
                disabled={this.state.authSession.isLoading}
                email={this.state.session.currentRecord.person.email}
                password={this.state.password}
                code={this.state.code}
                askCode={this.state.authType == "T"}
                noNewPassword={true}
                lockEmail={true}
                onChange={this.onChange}
            />
        );
    }

    /**
     *
     * @param {string} key
     * @param {SessionState} newState
     */
    loadingFinished(key, newState) {
        if (key === "authSession" && newState.action && newState.action.method === "post") {
            this.navigateForward();
        }
    }

    loadingFailed(key, newState) {
        super.loadingFailed(key, newState);
        if (key === "authSession") {
            if (newState.action.error && newState.action.error.reason === "auth:twoFactorRequired") {
                this.setState({
                    authType: "T"
                });
            } else {
                let errors = this.getErrorList(newState.action);
                this.setState({errors: errors});
            }
        }
    }

    onClickForward() {
        this.actions("authSession").post.defer({
            status: "P",
            authType: this.state.authType,
            person: {
                email: this.state.session.currentRecord.person.email,
                password: this.state.password,
                authCode: this.state.code
            }
        });
    }

    onChange(field, value) {
        this.setState({[field]: value});
    }
}

export default StepAuthenticate;
